"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCache = createCache;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @file 数据缓存类，以 kv 结构缓存数据，可以设置实例的数据缓存时间或单个 key 的缓存时间
 * @author picheng@sensorsdata.cn
 */

/**
 * 数据缓存
 */
var dataCenter = {}; // 实例 ID

var index = 0;

var DataCache =
/*#__PURE__*/
function () {
  /**
   * @param {Object=} options 配置
   * @param {number=} options.expires 过期时间，单位：毫秒，默认：1000 * 60 * 2
   */
  function DataCache(options) {
    _classCallCheck(this, DataCache);

    this.options = _objectSpread({
      expires: 120000
    }, options);
    this.__id__ = ++index;
    dataCenter[this.__id__] = {};
  }
  /**
   * 添加数据
   *
   * @param {string} key 数据 key
   * @param {*} value 数据 value
   * @param {number=} expires 过期时间，单位：毫秒，未设置则取实例配置
   */


  _createClass(DataCache, [{
    key: "set",
    value: function set(key, value, expires) {
      dataCenter[this.__id__][key] = {
        value: value,
        date: Date.now(),
        expires: expires || this.options.expires
      };
    }
    /**
     * 获取数据
     *
     * @param {string} key
     */

  }, {
    key: "get",
    value: function get(key) {
      var data = dataCenter[this.__id__][key];

      if (data) {
        if (Date.now() - data.date < data.expires) {
          if (data.value instanceof Array) {
            return _toConsumableArray(data.value);
          }

          if (_typeof(data.value)) {
            return _objectSpread({}, data.value);
          }

          return data.value;
        } // 过期了就删除


        this.del(key);
      }
    }
    /**
     * 删除数据
     *
     * @param {string} key
     */

  }, {
    key: "del",
    value: function del(key) {
      Reflect.deleteProperty(dataCenter[this.__id__], key);
    }
    /**
     * 清空缓存
     */

  }, {
    key: "clean",
    value: function clean() {
      dataCenter[this.__id__] = {};
    }
  }]);

  return DataCache;
}();
/**
 * 创建一个 DataCache 实例
 */


function createCache(options) {
  return new DataCache(options);
}